import { withErrorHandling } from '@selfserve/react-hocs';
import { UnisphereRuntimeVisual } from '@unisphere/runtime-react';
import { Box } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { IContextData } from './account-layout';
import { useEffect, useMemo } from 'react';
import { ApplicationFeatures, PageType, routesPaths, trackPageLoadEvent } from '@selfserve/react-utils';


export const Usage = withErrorHandling(({ openErrorModal }) => {
  const navigate = useNavigate();
  const { subscriptionOverviewData } = useOutletContext<IContextData>() || {};

  const showUsage = useMemo(() => {
    const subWithUsage = subscriptionOverviewData?.subscriptionInfoList?.find(sub => sub.planItem?.product_family === 'AVATAR_STUDIO');
    return !!subWithUsage;
  }, [subscriptionOverviewData]);

  useEffect(() => {
    if (!subscriptionOverviewData || !showUsage) {
      // In case the page was accessed directly using deep link
      navigate(routesPaths.MANAGEMENT_OVERVIEW, { replace: true });
    }
  }, [navigate, showUsage, subscriptionOverviewData]);

  useEffect(() => {
    trackPageLoadEvent(
      PageType.Analytics,
      'account_management_usage_page',
      ApplicationFeatures.ACCOUNT_MANAGEMENT,
    );
  }, []);

  return (
    <Box className={'usage-root'} sx={{ height: '100%', marginTop: '8px' }}>
      <UnisphereRuntimeVisual
        runtimeName={"usage-react"}
        widgetName={"unisphere.widget.plg"}
        visualType={"dashboard"}
        visualSettings={{}}
      />
    </Box>
  );
});
